// extracted by css-extract-rspack-plugin
export default {"body":"RelationshipsAlertDialog-module__body__hA6A3","footer":"RelationshipsAlertDialog-module__footer__gTIMF"};